import React from "react";
import PropTypes from "prop-types";
import { List, Button, Checkbox, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { setTaskDone, removeTask } from "../../../actions/planer";

/**
 * PlanerListView: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * List view component displaying a list of planer tasks and
 * allowing the user to change the task status or remove them.
 *
 * @param {*} props
 */
const PlanerListView = props => (
  <div>
    <List>
      {props.items.map(task => (
        <List.Item key={task.id}>
          <List.Content floated="right">
            <Button onClick={() => props.removeTask(task.id)} compact>
              <Icon name="trash" />
            </Button>
          </List.Content>
          <List.Content>
            <Checkbox
              label={task.title}
              checked={task.done || false}
              onChange={(_, { checked }) => props.setTaskDone(task.id, checked)}
            />
          </List.Content>
        </List.Item>
      ))}
    </List>
  </div>
);

const mapStateToProps = state => ({
  items: state.planer.tasks || []
});

PlanerListView.propTypes = {
  /**
   * items: [Object]
   * Array of task items to display in the list
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      done: PropTypes.bool.isRequired
    })
  ).isRequired
};

export default connect(
  mapStateToProps,
  { setTaskDone, removeTask }
)(PlanerListView);



// WEBPACK FOOTER //
// ./src/modules/agenda/planer/PlanerListView.js